import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsButtonBMobil(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Ebene 1"
      viewBox="0 0 61.85 43"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M50.36 16.37c-.87 0-1.7.1-2.51.28L43.49 6.28l3.82-.1c.17.03.8.17 1.08.6.3.45.16 1.17 0 1.68-.19.58.13 1.2.72 1.39.57.19 1.2-.13 1.39-.71.46-1.43.37-2.64-.27-3.59-.92-1.38-2.58-1.56-2.77-1.58h-.12l-5.52.13c-.37 0-.71.2-.9.5-.2.31-.24.7-.1 1.03l1.8 4.28-19.43.26-1.23-2.62h3.79c.72 0 1.31-.59 1.31-1.32s-.58-1.31-1.31-1.31h-9.11a1.314 1.314 0 0 0 0 2.63h2.88l1.6 3.4-4.28 6.74c-1.59-.85-3.4-1.33-5.33-1.33C5.28 16.37.2 21.44.2 27.68S5.28 39 11.52 39s10.9-4.68 11.29-10.57l6.52-.03.99 2.09c-.32.29-.51.7-.51 1.16 0 .88.71 1.58 1.57 1.58h1.25a1.575 1.575 0 1 0 0-3.15h-.07l-1.19-2.55 12.56-14.52 1.82 4.34c-3.94 1.76-6.7 5.73-6.7 10.32 0 6.25 5.07 11.32 11.31 11.32s11.32-5.07 11.32-11.32-5.08-11.31-11.32-11.31ZM17.5 20.82a9.083 9.083 0 0 1 3.01 5.42l-6.47.02 3.46-5.44Zm-5.97 15.97c-5.02 0-9.11-4.08-9.11-9.11s4.09-9.1 9.11-9.1c1.48 0 2.9.36 4.14 1l-4.57 7.2c-.21.34-.23.78-.04 1.13.19.34.57.57.97.57l8.56-.04a9.099 9.099 0 0 1-9.07 8.35Zm11.22-10.56c-.37-2.93-1.87-5.52-4.05-7.29l3.56-5.59 6.05 12.87-5.56.02Zm7.6-.88-6.11-12.98 17.52-.22-11.41 13.2Zm20.02 11.44c-5.02 0-9.1-4.08-9.1-9.11 0-3.69 2.19-6.86 5.35-8.29l3.54 8.41c.18.42.58.67 1.02.67.14 0 .29-.03.42-.09.57-.23.83-.88.59-1.44l-3.46-8.22c.53-.1 1.08-.15 1.64-.15 5.02 0 9.11 4.08 9.11 9.1s-4.09 9.11-9.11 9.11Z"
        style={{
          fill: '#005096',
        }}
      />
    </svg>
  )
}
export default SvgMsKlimadashboardIconsButtonBMobil
